import axios from "axios";

export const security = {
    namespaced: true,
    state: {
        userData: null,
        authProcessStatus: true
    },
    mutations: {
        setAuthInProgress(state, status) {
            state.authProcessStatus = status;
        },
        setUserData(state, userData) {
            state.userData = {
                id: userData.id,
                first_name: userData.first_name,
                last_name: userData.last_name,
                braintree: userData.braintree,
                addresses: userData.addresses,
            };
        }
    },
    actions: {
        async check(context) {
            try {
                const response = await axios.get('/api/user/me');

                context.commit("setUserData", response.data.data);

                return response;
            } catch (e) {
                console.warn(e);

                return false;
            } finally {
                context.commit("setAuthInProgress", false);
            }
        }
    },
    getters: {
        userData(state) {
            return state.userData;
        },
        authProgressStatus(state) {
            return state.authProcessStatus;
        }
    }
};
